import { z } from 'zod';

export const WEB_CONFIG_SCHEMA = z.object({
  VITE_WC_PROJECT_ID: z
    .string()
    .min(1)
    .describe('WalletConnect project ID (example: ba592d626408bb37e94c6a69ab611dab)'),
  VITE_VOLTA_RPC_ENDPOINT: z
    .string()
    .url()
    .describe(
      'Volta RPC endpoint URL (example: https://volta-rpc-vkn5r5zx4ke71f9hcu0c.energyweb.org)',
    ),
  VITE_VOLTA_WS_ENDPOINT: z
    .string()
    .url()
    .describe(
      'Volta WebSocket endpoint URL (example: wss://volta-ws-vkn5r5zx4ke71f9hcu0c.energyweb.org)',
    ),
  VITE_EWX_ADDRESS: z
    .string()
    .optional()
    .describe('Energy Web Exchange address (example: 5G88888888888888888888888888888888888888)'),
  VITE_AVT_CONTRACT_ADDRESS: z
    .string()
    .describe('AVT contract address (example: 0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee)'),
  VITE_REQ_EWX_SLEEP: z
    .string()
    .optional()
    .describe('Request Energy Web Exchange sleep (example: 1000)'),
  VITE_EWC_CHAIN_ID: z.string().describe('Energy Web Chain ID (example: 73799)'),
  VITE_ETH_CHAIN_ID: z.string().describe('Ethereum Chain ID (example: 1)'),
  VITE_ETH_RPC_ENDPOINT: z
    .string()
    .url()
    .describe(
      'Ethereum RPC endpoint URL (example: https://eth-mainnet.g.alchemy.com/v2/YOUR_API_KEY)',
    ),
  VITE_ETH_EXPLORER_URL: z
    .string()
    .url()
    .describe('Ethereum explorer URL (example: https://etherscan.io/tx)'),
  VITE_WC_RELAY_URL: z
    .string()
    .url()
    .describe('WalletConnect relay URL (example: wss://relay.walletconnect.com)'),
  VITE_EWC_SMART_CONTRACT: z
    .string()
    .min(1)
    .describe('EWC smart contract address (example: 0xEcF5A09B8Da2F316875ce4BbA86F5ABB88721f09)'),
  VITE_ETH_SMART_CONTRACT: z
    .string()
    .min(1)
    .describe(
      'Ethereum smart contract address (example: 0x0000000000000000000000000000000000000000)',
    ),
  VITE_POLKADOT_ENDPOINT: z
    .string()
    .url()
    .describe('Polkadot node endpoint URL (example: https://wnp-rpc.testnet.energywebx.com)'),
  VITE_POLKADOT_PALLET_ENDPOINT: z
    .string()
    .url()
    .describe('Polkadot pallet endpoint URL (example: https://wnp-rpc.testnet.energywebx.com)'),
  VITE_POLKADOT_PALLET_ENDPOINT_PUBLIC: z
    .string()
    .url()
    .describe('Polkadot pallet endpoint URL (example: https://wnp-rpc.testnet.energywebx.com)'),
  VITE_EWX_CHAIN_ID: z
    .string()
    .describe('Energy Web Exchange chain ID (example: 5a51e04b88a4784d205091aa7bada002)'),
  VITE_ENVIRONMENT: z.string().optional().describe('Environment name'),
  VITE_WHITELIST_URL: z
    .string()
    .optional()
    .describe(
      'Whitelist service URL (example: https://marketplace-cdn.energyweb.org/ewf_marketplace_whitelist.json)',
    ),
  VITE_EWX_CHECK_UA: z
    .string()
    .min(1)
    .describe('Energy Web Exchange user agent check (example: ewx-marketplace)'),
  VITE_EWC_EXPLORER_URL: z
    .string()
    .optional()
    .describe('Energy Web Chain explorer URL (example: https://explorer.energyweb.org/tx)'),
  VITE_EWX_EXPLORER_URL: z
    .string()
    .optional()
    .describe(
      'Energy Web Exchange explorer URL (example: https://polkadot.js.org/apps/?rpc=wss%3A%2F%2Fpublic-rpc.mainnet.energywebx.com%2F#/explorer/query)',
    ),
  VITE_HERO_BANNER_DATA_URL: z
    .string()
    .url()
    .describe(
      'Hero banner data URL (example: https://marketplace-cdn.energyweb.org/remote-resources/hero-banner/hero-banner-data.json)',
    ),
  VITE_WORKER_CARD_DATA_URL: z
    .string()
    .url()
    .describe(
      'Worker card data URL (example: https://marketplace-cdn.energyweb.org/remote-resources/worker-card/worker-card-data.json)',
    ),
  VITE_NOTIFICATIONS_DATA_URL: z
    .string()
    .url()
    .describe(
      'Notifications data URL (example: https://raw.githubusercontent.com/azam-ismail/azam-ismail/dev/notification.json)',
    ),
  VITE_BLACKLISTED_SOLUTION_GROUPS_DATA_URL: z
    .string()
    .url()
    .describe('Blacklisted solution groups data URL'),
  VITE_IS_TEST_VERSION: z.string().optional().describe('Test version flag (example: true)'),
  VITE_DEV: z.string().optional().describe('Development mode flag'),
  VITE_BASE_URL_CDN: z
    .string()
    .optional()
    .describe('Base URL CDN (example: https://marketplace-dev-cdn.energyweb.org/base_urls.json)'),
  VITE_KYC_API_URL: z
    .string()
    .url()
    .describe('KYC API base URL (example: https://kyc-ewx-dev.bewygrene.xyz)'),
});
